// Container imports
const { SHOW, HIDE } = require('./actions')
const HeaderImageModalRecord = require('./record')

function headerImageModalReducer(
  state = HeaderImageModalRecord.hide(),
  { type, payload }
) {
  switch (type) {
    case SHOW:
      return HeaderImageModalRecord.show(payload)
    case HIDE:
      return HeaderImageModalRecord.hide()
    default:
      return state
  }
}

module.exports = headerImageModalReducer
